<div class="timeline-root">
  <p *ngIf="sortedPlaces.length === 0 && !missingDestination.show" class="timeline-empty">
    Geen verblijfplaatsen bekend.
  </p>

  <div *ngIf="sortedPlaces.length > 0 || missingDestination.show" class="timeline-list">
    <div *ngIf="missingDestination.show" class="timeline-entry">
      <span class="timeline-line" *ngIf="sortedPlaces.length > 0"></span>
      <span class="timeline-dot timeline-dot--danger"></span>

      <div class="timeline-card timeline-card--danger">
        <div class="timeline-row timeline-row--header">
          <div class="timeline-label">Afvoer</div>
          <div class="timeline-value">—</div>
        </div>
        <div class="timeline-row">
          <div class="timeline-label">Bedrijfstype</div>
          <div class="timeline-value muted">—</div>
        </div>
        <div class="timeline-row timeline-row--footer">
          <div class="timeline-label">Aanvoer</div>
          <div class="timeline-value status--missing">
            Aanvoermelding ontbreekt
            <span *ngIf="missingDestination.afterAfvoerDate" class="timeline-sub">
              Verwacht na afvoer op {{ formatRvoDisplayDate(missingDestination.afterAfvoerDate) }}
              <ng-container *ngIf="missingDestination.fromUbn"> vanaf UBN {{ missingDestination.fromUbn }}</ng-container>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngFor="let entry of sortedPlaces; trackBy: entryTrack; let i = index; let last = last"
      class="timeline-entry"
      [class.timeline-entry--last]="last"
    >
      <span class="timeline-line" *ngIf="!last"></span>
      <span class="timeline-dot"></span>

      <div class="timeline-card">
        <div class="timeline-row timeline-row--header">
          <div class="timeline-label">Afvoer</div>
          <div class="timeline-value" [ngClass]="afvoerClass(entry.afvoer)">
            {{ afvoerLabel(entry.afvoer, entry.plaats) }}
          </div>
        </div>
        <div class="timeline-row">
          <div class="timeline-label">UBN</div>
          <div class="timeline-value timeline-value--ubn">
            <span>{{ entry.plaats.meldingeenheid ?? '—' }}</span>
            <button
              *ngIf="entry.plaats.meldingeenheid"
              type="button"
              class="map-btn"
              title="Toon op kaart"
              (click)="openMap(entry.plaats)"
            >
              <fa-icon [icon]="['fal', 'map']"></fa-icon>
            </button>
          </div>
        </div>
        <div class="timeline-row">
          <div class="timeline-label">Bedrijfstype</div>
          <div class="timeline-value">
            {{ bedrijfstypeLabel(entry.plaats.typeBedrijfsvestiging) }}
            <span *ngIf="entry.plaats.typeBedrijfsvestiging" class="timeline-code">
              ({{ entry.plaats.typeBedrijfsvestiging }})
            </span>
          </div>
        </div>
        <div class="timeline-row timeline-row--footer">
          <div class="timeline-label">Aanvoer</div>
          <div class="timeline-value" [ngClass]="aanvoerClass(entry.aanvoer)">
            {{ aanvoerLabel(entry.aanvoer, entry.plaats) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
